import { PROMO_VIDEO_ID } from '@/lib/constants';

/**
 * Guarded YouTube promo embed. Uses the privacy-friendly youtube-nocookie.com
 * domain (no tracking cookies until playback; that origin is allowlisted in the
 * CSP frame-src in index.html). Renders nothing when no video id is configured,
 * so callers never show a broken player. `className` tunes the wrapper width
 * (e.g. `max-w-2xl`) per placement; the box stays 16:9 and responsive.
 */
export default function PromoVideo({
  className = '',
  videoId = PROMO_VIDEO_ID,
  title = 'What is Polymyth?',
}: {
  className?: string;
  videoId?: string;
  title?: string;
}) {
  if (!videoId) return null;

  return (
    <div className={`aspect-[16/9] w-full overflow-hidden rounded-lg border ${className}`}>
      <iframe
        title={title}
        src={`https://www.youtube-nocookie.com/embed/${videoId}?rel=0`}
        className="h-full w-full border-0"
        loading="lazy"
        allow="encrypted-media; picture-in-picture; clipboard-write; web-share"
        allowFullScreen
      />
    </div>
  );
}
